import React from 'react';
import { connect } from 'react-redux';
import {
  Form,
  FormGroup,
  Button,
  Label,
  Alert,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import {
  Field,
  FieldArray,
  reduxForm,
  stopSubmit,
  formValueSelector,
  getFormValues,
} from 'redux-form';

import SelectDropdown from '../../../system/fields/SelectDropdown';
import Repeater from '../../../system/fields/Repeater';
import TextInput from '../../../system/fields/TextInput';
import Wysiwyg from '../../../system/fields/Wysiwyg';

import DestinationLegs from './DestinationLegs';
import TravelLegs from './TravelLegs';
import GuideLegs from './GuideLegs';

import * as validations from '../../../system/utils/Validation';
import CruiseLegs from './CruiseLegs';
import LegsWrapper from './Legs';

const selector = formValueSelector('DealForm');

class OptionTabs extends React.Component {
  constructor(props, option, index, fields, legType) {
    super(props);
  }
  state = {
    activeTab: 0,
  };

  remove(index) {
    const result = window.confirm('Are you sure you want to remove this row?');
    if (result) {
      this.props.fields.remove(index);
    }
  }
  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  render() {
    const options = this.props.options;
    const fields = this.props.fields;

    return (
      <section className='edit-form'>
        <div className='top-field'>
          <Nav tabs>
            {fields.map((each, i) => (
              <NavItem>
                <NavLink
                  className={this.state.activeTab === i ? 'active' : ''}
                  onClick={() => {
                    this.toggleTab(i);
                  }}
                >
                  {options[i].name === '' ? 'New option' : options[i].name}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
          <TabContent activeTab={this.state.activeTab}>
            {fields.map((field, i) => (
              <TabPane tabId={i} style={{ position: 'relative' }}>
                <div style={{ position: 'absolute', top: '0', right: '0' }}>
                  <div
                    style={{
                      display: 'flex',
                      background: '#dc3545',
                      color: 'white',
                      padding: '10px',
                      borderRadius: '5px',
                    }}
                    onClick={() => {
                      const result = window.confirm(
                        'Are you sure you want to remove this option?'
                      );
                      if (result) {
                        fields.remove(i);
                      }
                    }}
                  >
                    <i className='far fa-trash-alt' />
                    <p style={{ marginLeft: '5px', marginBottom: '0' }}>
                      Remove{' '}
                      {options[i].name === '' ? 'New option' : options[i].name}
                    </p>
                  </div>
                </div>
                <Field
                  name={`${field}.order`}
                  type='hidden'
                  value={i}
                  component={TextInput}
                  valueKey='value'
                  labelKey='name'
                  placeholder='Order'
                />
                <FormGroup
                  className='col-12 col-sm-6'
                  style={{ marginTop: '25px' }}
                >
                  <Label>Option Name</Label>
                  <Field
                    name={`${field}.name`}
                    type='text'
                    component={TextInput}
                    valueKey='value'
                    labelKey='name'
                    defaultValue={options[i].name}
                    placeholder='Option Name'
                  />{' '}
                </FormGroup>

                <FormGroup className='col-12 '>
                  <Label>Description</Label>
                  <Field
                    name={`${field}.description`}
                    type='text'
                    component={Wysiwyg}
                    valueKey='value'
                    labelKey='name'
                    placeholder='Description'
                  />
                </FormGroup>
                <FieldArray name={`${field}.legs`} component={renderLegs} OIndex={i} />
              </TabPane>
            ))}
          </TabContent>
        </div>
      </section>
    );
  }
}

const renderLegs = ({ fields,OIndex,  meta: { touched, error } }) => (
  <div className='repeater-container pb-5 mb-5'>
    {fields.map((leg, index) => (
      <React.Fragment>
        <LegsWrapper leg={leg} fields={fields} index={index} key={index} OIndex={OIndex} />
      </React.Fragment>
    ))}

    <div className='add-button bottom'>
      <Button
        type='button'
        onClick={() => fields.push({ leg_type: '', legs: [] })}
      >
        Add Leg
      </Button>
    </div>
  </div>
);

const OptionsWrapper = connect((state, props) => ({
  name: selector(state, `${props.option}.name`),
  options: selector(state, 'options'),
}))(OptionTabs);

export default OptionsWrapper;



// WEBPACK FOOTER //
// ./src/containers/Deals/components/OptionTabs.jsx